import { useState } from "react";
import { FluentSignOut24Filled } from "../../../assets/icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../../features/auth/authSlice";
import capitalBrewLogo from "../../../assets/images/capital brew logo.png";
import { showToast } from "../../../toastify/Toast";
import UserDetails from "../../modals/UserDetails";
import ProfileDetails from "../../modals/ProfileDetails";
import UpdateProfileDetails from "../../modals/UpdateProfileDetails";
import { clearTypeOfShowModalType, selectCurrentShowTypeOfModal, setTypeOfShowModalType } from "../../../features/modal/modalSlice";
import { useGetUserInitial } from "../../../hooks/useGetUserInitial";
import ConfirmationModal from "../../modals/ConfirmationModal";
import { useStaffLogOutMutation } from "../../../features/auth/authApiSlice";

export default function CashierNavbar() {

    const dispatch = useDispatch();
    const userInitial = useGetUserInitial()
    const [isLogOutOpen, setIsLogOutOpen] = useState<boolean>(false);
    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    const [logout, { isLoading: isLoadingStaffLogOut, isError: isErrorStaffLogOut }] = useStaffLogOutMutation();

    const handleLogOut = async () => {
        try {
            await logout().unwrap();
            dispatch(logOut());
            window.location.href = "/login-staff";
            showToast('Logout successfully.', 'success');
        } catch (error) {
            showToast("Logout failed!", "error");
        }
    }

    const handleShowUserDetails = () => {
        setIsLogOutOpen(false)
        if (typeOfModalShow === "viewUserDetails") {
            dispatch(clearTypeOfShowModalType());
        } else {
            dispatch(setTypeOfShowModalType("viewUserDetails"));
        }
    }

    return (
        <div className="w-full flex justify-center items-center fixed bg-white shadow-md z-50">
            <div className="container lg:px-8">
                <div className="flex justify-between items-center h-16 lg:container">
                    <div className="flex items-center gap-3 cursor-pointer">
                        <img
                            src={capitalBrewLogo}
                            alt="Admin Dashboard"
                            className="h-8 w-auto object-contain"
                        />
                    </div>

                    <div className="flex items-center gap-3 relative">
                        <button
                            onClick={handleShowUserDetails}
                            className={`relative text-sm px-4 py-2 rounded-lg font-medium transition-all bg-cbColor text-white shadow-md`}
                        >
                            {userInitial}
                        </button>

                        {typeOfModalShow === 'viewUserDetails' && (
                            <UserDetails />
                        )}

                        {typeOfModalShow === 'viewProfileDetails' && (
                            <ProfileDetails />
                        )}

                        {typeOfModalShow === 'viewAndUpdateUserDetails' && (
                            <UpdateProfileDetails />
                        )}


                        <button
                            onClick={() => setIsLogOutOpen(true)}
                            className="flex space-x-2 items-center text-black text-sm font-medium rounded-lg transition bg-cbColor px-4 py-2.5"
                        >
                            <span>
                                <FluentSignOut24Filled height={16} width={16} color='white'/>{" "}
                            </span>
                        </button>

                        {isLogOutOpen && (
                            <ConfirmationModal
                                onCancel={() => {
                                    setIsLogOutOpen(false)
                                }}
                                onConfirm={handleLogOut}
                                isLoading={isLoadingStaffLogOut}
                                modalTitle={`Logout`}
                                modalSubTitle={`Are you sure you want to logout?`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
